import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import { IRoute } from "src/common/typings/routes";
import { Insights } from "./Insights";
import { Listing } from "./pages/Listing/index";

export const InsightsRoute: IRoute = {
  title: "Insights",
  path: "/insights",
  icon: HomeIcon,
  component: Insights,
  guard: true,
  subRoutes: [{ icon: InfoIcon, component: Listing, path: "/insights", title: "Insights" }],
};
